import React from 'react'

const CreateCardContext = React.createContext<{
  isCreating: boolean
  setIsCreating: (boolean) => void

  /**
   * We use this to disable the "Save" button in the payment method form if the card form is open
   * to prevent the user from exiting the modal without saving the card
   */
  isCardFormOpen: boolean
  setIsCardFormOpen: (boolean) => void
}>({
  isCreating: false,
  setIsCreating: () => {},
  isCardFormOpen: false,
  setIsCardFormOpen: () => {}
})

export default CreateCardContext
